import { cn } from '@spiaggeit/spit-ui'
import { useTranslation } from 'react-i18next'

import {
  getReservationConstraintMessage,
  hasConfiguredMaximum,
  hasConfiguredMinimum,
} from '@/utils/getReservationConstraintMessage'
import { TicketConstraintLinesProps } from '@/utils/mapPageErrorPresentation'

export function TicketConstraintLines({
  constraintClassName,
  constraintScope,
  errorAnchor,
  hasMaxError = false,
  hasMinError = false,
  maximumQuantity,
  minimumQuantity,
}: TicketConstraintLinesProps) {
  const { t } = useTranslation()

  const message = getReservationConstraintMessage(
    t,
    { maximumQuantity, minimumQuantity },
    constraintScope
  )

  if (!message) {
    return null
  }

  const hasError =
    (hasMinError && hasConfiguredMinimum(minimumQuantity)) ||
    (hasMaxError && hasConfiguredMaximum(maximumQuantity))

  return (
    <div data-ticket-error-anchor={errorAnchor}>
      <p
        className={cn('mt-1 text-sm', constraintClassName, {
          'text-neutral-500': !hasError && !constraintClassName,
          'text-red-600': hasError,
        })}
      >
        {message}
      </p>
    </div>
  )
}
